import photoConfig from 'ui-theme/widgets/axel-publication-content/js/config';

const config = photoConfig;
config.articlePageHeader.selector = 'header.header, #js-secondary-menu';
config.collateral.AFFILIATIONS = '';
config.collateral.figures.graphic.renderNotes = true;
config.collateral.figures.table.renderTitle = true;
config.smartTables.enabled = true;
config.getFtr = {
    ...photoConfig.getFtr,
    enabled: true,
    selectors: {
        body: {
            external: '.info-panel__formats > .core-get-ftr',
            internal: '',
        },
        collateral: null,
    },
};

export default config;
